<template>
  <cb-notification-bar
    :test-id="`${level}-level-read-only-notification-banner`"
    variant="info"
    showCloseButton
    @on-close="handleClose"
    v-if="!isBannerClosed && visible"
  >
    <template #title>
      {{ t("banner-title-read-only-role") }}
    </template>
    <template #description>
      {{ t("banner-text-read-only-role") }}
    </template>
  </cb-notification-bar>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { BANNER_COOKIE } from "@/constants/banner-cookie";
import { computed, ref } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

const { t } = useI18n();
const cookies = useCookies();

const cookieKey = ref<string>(BANNER_COOKIE.READ_ONLY_ROLE_BANNER_CLOSED);

type Props = {
  level: string;
  visible?: boolean;
};
withDefaults(defineProps<Props>(), {
  visible: false,
});

const handleClose = () => {
  cookies.set(cookieKey.value, true);
};

const isBannerClosed = computed<boolean>(() => cookies.get(cookieKey.value));
</script>

<style scoped></style>
